import React, { useEffect, useState } from 'react';
import Popover from 'antd/lib/popover';
import Button from 'antd/lib/button';
import Badge from 'antd/lib/badge';
import Icon from 'antd/lib/icon';
import IconList from './IconList';
import * as FishxIcons from '@fishx/icons';
import { createFromIconfontCN } from '@fishx/icons';

const allIcons: {
  [key: string]: any;
} = FishxIcons;
const IconPicker = ({
  mode = 'inline',
  defaultValue,
  value,
  readonly = false,
  onChange,
  className = '',
  style = {},
  placeholder,
  overlayClassName,
  overlayStyle,
  displayFromIconfontCN,
  showClearBtn,
  showColorSelect,
}: {
  mode?: string;
  value?: any;
  readonly?: Boolean;
  defaultValue?: any;
  className: string;
  style: object;
  onChange?: Function;
  placeholder?: string;
  overlayClassName?: string;
  overlayStyle?: object;
  displayFromIconfontCN?: string;
  showClearBtn?: Boolean;
  showColorSelect?: Boolean;
}) => {
  const [iconType, setIconType] = useState(value || defaultValue);
  const [showDot, setShowDot] = useState(false);
  const [currentColor, setCurrentColor] = useState('');
  const [selectedColor, setSelectedColor] = useState('');
  const Component = allIcons[iconType];
  const departmentIconList = React.useMemo(
    () => Object.keys(allIcons).filter(iconName => iconName.indexOf('P') === 0 && iconName.substring(1, 2).match(/^.*[A-Z]+.*$/)),
    [],
  );
  const IconFont = createFromIconfontCN({
    scriptUrl: displayFromIconfontCN,
  });
  useEffect(() => {
    setCurrentColor(null);
  }, [currentColor]);
  const handleHover = (v) => {
    if (showClearBtn && mode !== 'inline' && iconType) {
      setShowDot(v);
    }
  }
  const handleClick = () => {
    if (showClearBtn && mode !== 'inline' && iconType) {
      setIconType('');
      setShowDot(false);
      setCurrentColor('');
      setSelectedColor('')

    }
  }
  const defaultStyle: any = {
    padding: '8px',
    maxHeight: '250px',
    overflowY: 'auto'
  };
  const modalStaticEl = () => (
    <div
      onMouseLeave={() => { handleHover(false) }}
      style={{ display: 'inline-block' }}
    >
      <Badge count={<Icon type="close-circle" theme="filled" style={{ color: '#EF222C', fontSize: '16px', visibility: (showDot ? 'visible' : 'hidden'), opacity: (showDot ? 1 : 0), transition: 'all 0.3s ease-in-out' }} onClick={() => handleClick()} />} >
        <Button
          className={`cursor-pointer ${className}`}
          style={style}
          onMouseEnter={() => { handleHover(true) }}
        >
          {!iconType ? (placeholder || 'please select') : (displayFromIconfontCN ? <IconFont type={iconType} style={{ color: selectedColor }} /> : <Component style={{ color: selectedColor }} />)}
        </Button>
      </Badge>
    </div>
  );
  const ModalEl = (
    <Popover
      overlayClassName={overlayClassName || "defaultOverlay"}
      overlayStyle={overlayStyle || { width: '319px' }}
      trigger="click"
      placement="topLeft"
      content={
        <IconList
          dataSource={departmentIconList}
          currentIcon={iconType}
          setIconType={setIconType}
          iconChange={onChange}
          readonly={readonly}
          displayFromIconfontCN={displayFromIconfontCN}
          showColorSelect={showColorSelect}
          currentColor={currentColor}
          colorChange={setSelectedColor}
        />
      }
    >
      {modalStaticEl()}
    </Popover>
  );


  return (
    <React.Fragment>
      {
        mode === 'inline'
          ? (
            <div className={className} style={{ ...defaultStyle, ...style }}>
              <IconList
                dataSource={departmentIconList}
                currentIcon={iconType}
                setIconType={setIconType}
                iconChange={onChange}
                readonly={readonly}
                displayFromIconfontCN={displayFromIconfontCN}
              />
            </div>
          )
          : (
            readonly ? modalStaticEl() : ModalEl
          )
      }
    </React.Fragment>
  );
};
export default IconPicker;



// WEBPACK FOOTER //
// ./src/components/icon-picker/index.tsx